<template>
  <div class="scpm-date-range">
    <lego-icon :size="16" icon="scpm_date_range" />
    <span>{{ formatDate(fromDateValue) }}</span>
    <span>~</span>
    <span>{{ formatDate(toDateValue) }}</span>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'ScpmDateRange',
  props: {
    fromDate: {
      type: [String, Number],
      default: () => ''
    },
    toDate: {
      type: [String, Number],
      default: () => ''
    },
    format: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    fromDate: {
      immediate: true,
      handler(value) {
        this.fromDateValue = value;
      },
    },
    toDate: {
      immediate: true,
      handler(value) {
        this.toDateValue = value;
      },
    },
  },
  data() {
    return {
      fromDateValue: '',
      toDateValue: ''
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';

      if (this.format) {
        if (typeof date == 'string') {
          return moment(new Date(date)).format(this.format);
        }
        return moment(date * 1000).format(this.format);
      }
      return date;
    }
  }
};
</script>
<style lang="scss" scoped>
.scpm-date-range {
  display: flex;
  gap: 4px;
  align-items: center;
  span {
    font-family:$lego__font-family;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color: #2f3237;
  }
}
</style>
